import { PermissionsBaseModel } from '@fluxonos/features/user/models/permissions-base.model';
import { UserPermissionsEnum } from '@fluxonos/fluxonos-dto';

export class PermissionsUserModel extends PermissionsBaseModel {
  public get canView(): boolean {
    const permissions = [UserPermissionsEnum.VIEW__FLUXONOS__USER_USER];
    return this.checkPermissions(permissions);
  }

  public get canChange(): boolean {
    if (!this.canView) {
      return false;
    }
    const permissions = [UserPermissionsEnum.CHANGE__FLUXONOS__USER_USER];
    return this.checkPermissions(permissions);
  }

  public get canAdd(): boolean {
    if (!this.canView) {
      return false;
    }
    const permissions = [UserPermissionsEnum.ADD__FLUXONOS__USER_USER];
    return this.checkPermissions(permissions);
  }

  public get canDelete(): boolean {
    if (!this.canView) {
      return false;
    }
    const permissions = [UserPermissionsEnum.DELETE__FLUXONOS__USER_USER];
    return this.checkPermissions(permissions);
  }

  public get isAdmin(): boolean {
    return this.canView && this.canChange && this.canAdd && this.canDelete;
  }
}
